import { apiRequest } from './client'
import type { AppNotification, Paginated } from './types'

export const notificationsApi = {
  list: (unreadOnly = false) => apiRequest<Paginated<AppNotification>>('/notifications', { query: { unreadOnly, pageSize: 30 } }),

  unreadCount: () => apiRequest<{ data: { count: number } }>('/notifications/unread-count'),

  markRead: (id: string) => apiRequest<{ data: AppNotification }>(`/notifications/${id}/read`, { method: 'POST', body: {} }),

  markAllRead: () => apiRequest<{ data: { success: boolean } }>('/notifications/read-all', { method: 'POST', body: {} }),
}
